import {
  Box,
  Chip,
  LinearProgress,
  TableBody,
  TableCell,
  TableFooter,
  TablePagination,
  TableRow,
	makeStyles,
} from "@material-ui/core";
import InputSearch from "components/Input/InputSearch";
import React from "react";
import AppTable from "./Component/Table/AppTable";
import moment from "moment";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import AppUtil from "utilities/AppUtil";
import TablePaginationActions from "./Component/Table/TablePaginationActions";
import AppSelect from "components/Select/AppSelect";
import { fetchCompanyTransactionListPaging } from "store/slices/companyTransaction";
import AppConfig from "config/AppConfig";
import AppColor from "utilities/AppColor";
import { useEffect } from "react";

const headCells = [
  {
    id: "transactionId",
    numeric: "left",
    disablePadding: false,
    label: "label.transactionId",
    sort: true,
  },
  {
    id: "organizationName",
    numeric: "left",
    disablePadding: false,
    label: "label.company",
    sort: true,
  },
  {
    id: "packageName",
    numeric: "left",
    disablePadding: false,
    label: "label.subscriptionPlan",
    sort: true,
  },
  {
    id: "createdDate",
    numeric: "left",
    disablePadding: false,
    label: "label.date",
    sort: true,
  },
  {
    id: "pricing",
    numeric: "left",
    disablePadding: false,
    label: "label.price",
    sort: true,
  },
  {
    id: "transactionStatus",
    numeric: "left",
    disablePadding: false,
    label: "label.status",
    sort: true,
  }
];

const styles = makeStyles(() => ({
  shortText: {
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
    maxWidth: "376px",
  },
}));

const TransactionManagement = () => {

	const { t } = useTranslation();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [totalElements, setTotalElements] = useState(0);
  const [searchKey, setSearchKey] = useState("");
  const classes = styles();
  const [queries, setQueries] = useState({
    sort: true,
    page_number: 1,
    page_size: 10,
    search_key: "",
    sort_field: "createdDate",
    transaction_status: "",
  });

  const emptyRows = data.length === 0;

	const statusOptions = [
    {
      value: "SUCCESS",
      label: t("transaction_status.SUCCESS"),
    },
    {
      value: "REFUND",
      label: t("transaction_status.REFUND"),
    }
  ];

	const handleSelectApprovalStatus = (event) => {
    switch (event.target.value) {
      case "SUCCESS":
        _loadData({ ...queries, page_number: 1, transaction_status: "SUCCESS" });
        break;
      case "REFUND":
        _loadData({ ...queries, page_number: 1, transaction_status: "REFUND" });
        break;
      default:
        _loadData({ ...queries, page_number: 1, transaction_status: "" });
        break;
    }
  };

	const handleChangePage = (event, newPage) => {
    _loadData({ ...queries, page_number: newPage + 1 });
    AppUtil.scrollToTopById("main-panel");
  };
  const handleChangeRowsPerPage = (event) => {
    _loadData({
      ...queries,
      page_number: 1,
      page_size: parseInt(event.target.value),
    });
    AppUtil.scrollToTopById("main-panel");
  };
  const onRequestSort = (event, property) => {
    _loadData({
      ...queries,
      sort_field: property,
      sort:
        property === queries.sort_field ? queries.sort !== true : true,
    });
  };

  const onSearch = (value) => {
    setSearchKey(value);
    _loadData({
      ...queries,
      search_key: value,
      page_number: 1,
    });
  };

  const _loadData = async ({
    page_number,
    page_size,
    search_key,
    sort,
    sort_field,
    transaction_status,
  } = {}) => {
    const newQueries = {
      ...queries,
    };
    if (page_number) {
      newQueries.page_number = page_number;
    }
    if (page_size) {
      newQueries.page_size = page_size;
    }
    if (sort_field) {
      newQueries.sort_field = sort_field;
    }
    newQueries.transaction_status = transaction_status || "";
    newQueries.search_key = search_key || "";
    newQueries.sort = !(!sort || false);
    setLoading(true);
    dispatch(fetchCompanyTransactionListPaging(newQueries)).then(({ payload }) => {
      setQueries(newQueries);
      setLoading(false);
      if (payload) {
				setData(payload.content);
				setTotalElements(payload.totalElements);
      }
    });
  };

	const renderSelectField = ({ name, placeholder, options, onChange }) => (
    <AppSelect
      name={name}
      placeholder={t(placeholder)}
      options={options}
      onChange={(option) => {
        const params = {};
        if (option) {
          params[name] = option.value;
          onChange &&
            onChange({
              target: {
                name: name,
                value: option.value,
              },
            });
        } else {
          params[name] = "";
          onChange &&
            onChange({
              target: {
                name: name,
                value: "",
              },
            });
        }
      }}
      allowOverflow={true}
    />
  );

	useEffect(() => {
		_loadData();
	}, []);
  return (
    <Box>
      <Box my={3}>
        <InputSearch onSearch={onSearch} searchText={searchKey} />
      </Box>
			<Box my={3} style={{ width: "50%", margin: "10px 0px 10px 0px" }}>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div style={{ width: "42%" }}>
            {renderSelectField({
              name: "status",
              placeholder: "label.status",
              options: statusOptions,
              onChange: (e) => handleSelectApprovalStatus(e),
            })}
          </div>
        </div>
      </Box>
      <AppTable
        onRequestSort={onRequestSort}
        order={queries.sort === true ? "asc" : "desc"}
        orderBy={queries.sort_field}
        rowCount={data.length}
        headCells={headCells}
        // numSelected={selected.length}
        // onSelectAllClick={_handleSelectAll}
      >
        <TableBody>
          {loading && (
            <TableRow>
              <TableCell colSpan={7} padding="none">
                <LinearProgress />
              </TableCell>
            </TableRow>
          )}
          {
            data.map((row, index) => (
              <TableRow key={index}>
                <TableCell>
									{row.transactionId}
                  {/* {row.organizationName && row.organizationName.length > 32 ? (
                    <p className={classes.shortText}>{row.organizationName}</p>
                  ) : (
                    <span>{row.organizationName}</span>
                  )} */}
                </TableCell>
                <TableCell>
                {row.organizationName && row.organizationName.length > 32 ? (
                    <p className={classes.shortText}>{row.organizationName}</p>
                  ) : (
                    <span>{row.organizationName}</span>
                  )}
                </TableCell>
                <TableCell>
								{row.packageName && row.packageName.length > 32 ? (
                    <p className={classes.shortText}>{row.packageName}</p>
                  ) : (
                    <span>{row.packageName}</span>
                  )}
								</TableCell>
                <TableCell>
                  {moment
                    .utc(row.createdDate)
                    .local()
                    .format("yyyy/MM/DD HH:mm:ss")
                    .toString()}
                </TableCell>
                <TableCell>
									{`$${row.pricing}`}
                </TableCell>
                <TableCell>
									<Chip
                    style={{
											backgroundColor: row.transactionStatus === AppConfig.TRANSACTION_STATUS.SUCCESS ? AppColor.green
											:row.transactionStatus === AppConfig.TRANSACTION_STATUS.REFUND ? AppColor.gray : AppColor.red,
											color: AppColor.white
										}}
                    size="small"
                    label={t(`transaction_status.${row.transactionStatus}`)}
                  />
                </TableCell>
              </TableRow>
            ))}

          {emptyRows > 0 && (
            <TableRow style={{ height: 53 }}>
              <TableCell colSpan={headCells.length + 1} className="text-center">
                {t("label.no_data")}
              </TableCell>
            </TableRow>
          )}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              colSpan={headCells.length}
              count={totalElements}
              rowsPerPage={queries.page_size}
              page={queries.page_number - 1}
              SelectProps={{
                inputProps: { "aria-label": "rows per page" },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
              labelRowsPerPage={`${t("label.rows_per_page")}:`}
              labelDisplayedRows={({ from, to, count }) =>
                t("label.from_to", {
                  from,
                  to,
                  count: count !== -1 ? count : `${t("text.more_than")} ${to}`,
                })
              }
            />
          </TableRow>
        </TableFooter>
      </AppTable>
    </Box>
  );
};

export default TransactionManagement;
